/**
 * Centralized plan tier hierarchy.
 * To add a new tier, just insert it here with the correct level number.
 * All isPaidPlan / isEnterprisePlan checks across the codebase will pick it up automatically.
 */

export const PLAN_TIERS: Record<string, number> = {
  free: 0,
  pro: 1,
  enterprise: 2,
};

/** Returns true for any plan above "free" (pro, enterprise, or any future paid tier). */
export function isPaidPlan(plan: string | null | undefined): boolean {
  return (PLAN_TIERS[plan || "free"] ?? 0) >= 1;
}

/** Returns true only for enterprise-tier plans and above. */
export function isEnterprisePlan(plan: string | null | undefined): boolean {
  return (PLAN_TIERS[plan || "free"] ?? 0) >= 2;
}

/** Human-readable plan names, keyed by the DB enum value. */
export const PLAN_NAMES: Record<string, string> = {
  free: "Free",
  pro: "Pro",
  enterprise: "Enterprise",
};

/** Returns the display name for a plan, defaulting to "Free". */
export function getPlanName(plan: string | null | undefined): string {
  return PLAN_NAMES[plan || "free"] ?? plan ?? "Free";
}

/** Returns the highest-tier plan from a list of plan strings. */
export function getHighestPlan(plans: (string | null | undefined)[]): string {
  let max = 0;
  let maxPlan = "free";
  for (const p of plans) {
    const level = PLAN_TIERS[p || "free"] ?? 0;
    if (level > max) {
      max = level;
      maxPlan = p || "free";
    }
  }
  return maxPlan;
}
